import { render, staticRenderFns } from "./NewOrleansHeadTraumaRules.vue?vue&type=template&id=4f045fe2&scoped=true"
import script from "./NewOrleansHeadTraumaRules.vue?vue&type=script&lang=js"
export * from "./NewOrleansHeadTraumaRules.vue?vue&type=script&lang=js"
import style0 from "./NewOrleansHeadTraumaRules.vue?vue&type=style&index=0&id=4f045fe2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f045fe2",
  null
  
)

export default component.exports